import HeadDirection from './HeadDirection'
import { AnimationComponentProps as Props } from './phaseAnimation'

export default function HeadUp(props: Props) {
  return <HeadDirection direction="up" {...props} />
}
